export default {
  list: '/portal/events/',
  tabHash: ['eventLog'],
}
